import { Injectable } from '@angular/core'

@Injectable()
export class SoundService {

  messageSent = new Audio('assets/audio/message_sent.m4a')
  messageReceived = new Audio('assets/audio/message_received.m4a')
  error = new Audio('assets/audio/error.m4a')
  productAdded = new Audio('assets/audio/product_added.m4a')

  constructor() {
  }

  playProductAdded() {
    this.productAdded.play()
  }

  playError() {
    this.error.play()
  }

  playMessageReceived() {
    this.messageReceived.play()
  }

  playMessageSent() {
    this.messageSent.play()
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/sound/sound.service.ts